import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Clock, FileText } from 'lucide-react';

const ProcessingTimes = () => {
  const navigate = useNavigate();
  
  const articles = [
    {
      title: "Average Processing Times by Voivodeship",
      description: "Compare processing times across different Polish voivodeships",
      path: "/knowledge-base/processing-times/voivodeship-times"
    },
    {
      title: "How to Track Your Application Status",
      description: "Step-by-step guide to checking your application progress",
      path: "/knowledge-base/processing-times/track-status"
    },
    {
      title: "Expedited Processing Options",
      description: "Learn about available options for faster processing",
      path: "/knowledge-base/processing-times/expedited-options"
    },
    {
      title: "What to Do If Processing is Delayed",
      description: "Guidelines and solutions for handling delays",
      path: "/knowledge-base/processing-times/handling-delays"
    }
  ];

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <Clock className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Processing Times Guide
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Understanding residence permit processing times and tracking your application
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {articles.map((article, index) => (
            <Card 
              key={index}
              className="hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer"
              onClick={() => handleCardClick(article.path)}
            >
              <CardHeader>
                <CardTitle className="text-xl text-foreground">{article.title}</CardTitle>
                <CardDescription className="text-muted-foreground">
                  {article.description}
                </CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Knowledge Base
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProcessingTimes; 